export type Singleton<T> = () => T;

export const createSingleton = <T>(getInstance: (...params: any[]) => T): (Singleton<T>) => {
    let instance: T | null = null;
    let initialized = false;

    return (): T => {
        if (!initialized) {
            instance = getInstance();
            initialized = true;
        }
        return instance;
    };
}